import { ChipV2, Text } from "@asayinc/component-library";
import { Add } from "@mui/icons-material";
import { Box, Stack } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Card } from "src/components/atoms/Card";
import { CreateTabulationReportDialog } from "src/components/organisms/CreateTabulationReportDialog";
import { ErrorState } from "src/components/atoms/ErrorState";
import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { LoadingCard } from "src/components/molecules/Loading";
import { TabulationList } from "src/components/molecules/TabulationList";
import { useTabulationReportsQuery } from "src/store/tabulation";
import { useCurrentUserQuery } from "src/store/user";

export function ProxyEventTabulationReportsTab() {
  const { id: proxyId } = useParams() as { id: string };
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const { isLoading, error } = useTabulationReportsQuery({ proxyId });
  const { data: currentUser } = useCurrentUserQuery();

  const isAdmin =
    currentUser?.isIntermediaryPortalAdmin ||
    currentUser?.isIntermediaryPortalSuperAdmin;

  if (error || (!isLoading && error)) {
    return <ErrorState />;
  }

  if (isLoading) {
    return (
      <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
        <LoadingCard />
      </ScrollContainer>
    );
  }

  return (
    <>
      <CreateTabulationReportDialog
        isOpen={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
      />
      <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
        <Card title="Tabulation Reports">
          <Stack sx={{ p: 6 }}>
            <TabulationList />
            {isAdmin && (
              <Box
                sx={{
                  backgroundColor: "#F0F0F0",
                  borderRadius: "8px",
                  p: 4,
                }}
                data-testid="send-tabulation"
              >
                <Text sx={{ mb: 3 }} variant="body3">
                  Click to create new tabulation report
                </Text>
                <ChipV2
                  onClick={() => setCreateDialogOpen(true)}
                  icon={<Add />}
                  size="small"
                  label="Send another tabulation report now"
                  variant="secondaryOutline"
                  sx={{
                    borderColor: "#E0E0E0",
                    backgroundColor: "#F0F0F0",
                    cursor: "pointer",
                  }}
                />
              </Box>
            )}
          </Stack>
        </Card>
      </ScrollContainer>
    </>
  );
}
